import PropTypes from "prop-types"
import parse from "html-react-parser"

import { serviceShape, tqaShape } from "app/lib/shared_prop_types"
import proPlusBadge from "images/plan-badges/pro_plus.svg"
import proBadge from "images/plan-badges/pro.svg"

import "./header.scss"

const TQAHeader = ({ service, tqa, servicePath, serviceImg }) => {
  const proBadgeVisibility = { visibility: tqa.tier !== "free" ? "visible" : "hidden" }

  return (
    <section className="service-header tqa-header">
      <div className="brand-section" styleName="brand-section">
        <a href={servicePath} title={service.name} rel="noreferrer" styleName="brand-link">
          <img
            styleName="small-service-logo"
            src={serviceImg}
            alt={service.name}
            title={service.name}
            width="32"
            height="32"
          />
          {service.name}
        </a>
        <h1>{tqa.name}</h1>
        <p styleName="brand-description">
          <a href="/plans" title="IFTTT Pro Plans" styleName="badge-container" style={proBadgeVisibility}>
            <span className="card-badge">{parse(tqa.tier === "pro" ? proPlusBadge : proBadge)}</span>
          </a>
          {tqa.description}
        </p>
      </div>
    </section>
  )
}

TQAHeader.propTypes = {
  service: serviceShape.isRequired,
  tqa: tqaShape.isRequired,
  servicePath: PropTypes.string.isRequired,
  serviceImg: PropTypes.string.isRequired,
}

export default TQAHeader
